export const VIDEO_DETAILS_LOADING = "VIDEO_DETAILS_LOADING";
export const VIDEO_DETAILS_SUCCESS = "VIDEO_DETAILS_SUCCESS";
export const VIDEO_DETAILS_FAILURE = "VIDEO_DETAILS_FAILURE";
export const EXTRA_TYPES_DETAILS = "EXTRA_TYPE_DETAILS";